import React from "react";
import "./ButtonSignInProvider.css"; // Import the CSS for styling
import googleLogo from "../../images/google2.png"; // Assuming you have the logo in this directory
import facebookLogo from "../../images/facebook.png"; // Add more logos as needed
import githubLogo from "../../images/github.png"; // Add more logos as needed

const ButtonSignInProvider = ({ providerName, label, onClick }) => {
  // Determine the provider logo based on the providerName prop
  const getProviderLogo = (provider) => {
    switch (provider.toLowerCase()) {
      case "google":
        return googleLogo;
      case "facebook":
        return facebookLogo;
      case "github":
        return githubLogo;
      default:
        return null;
    }
  };

  const providerLogo = getProviderLogo(providerName);

  return (
    <button className="button-signin-provider" onClick={onClick}>
      <div className="button-logo-circle">
        <img src={providerLogo} alt={`${providerName} logo`} />
      </div>
      <div className="button-label">{label}</div>
    </button>
  );
};

export default ButtonSignInProvider;
